import { useState, useEffect } from 'react';
import { Grid, Box, Button } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CariStruk from './CariStruk';
import CekTarif from './CekTarif';
import { Skeleton } from '@material-ui/lab';

const Fade = require('react-reveal/Fade');

const SkeletonTarifStruk = () => (
  <>
    <Grid item xs={12} md={4}>
      <Skeleton variant='rect' height={50} style={{ marginBottom: 8 }} />
      <Skeleton variant='rect' height={300} style={{ marginBottom: 8 }} />
      <Skeleton variant='rect' height={37} width={100} />
    </Grid>
    <Grid item xs={12} md={4}>
      <Skeleton variant='rect' height={300} style={{ marginBottom: 8 }} />
      <Skeleton variant='rect' height={100} />
    </Grid>
    <Grid item xs={12} md={4}>
      <Skeleton variant='rect' height={50} style={{ marginBottom: 8 }} />
      <Skeleton variant='rect' height={300} style={{ marginBottom: 8 }} />
      <Skeleton variant='rect' height={37} width={100} />
    </Grid>
  </>
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      padding: '32px 16px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingTop: 127,
      '@media screen and (max-width: 1919px)': {
        minHeight: 'initial',
        padding: '6rem 1rem',
      },
      [theme.breakpoints.up(2550)]: {
        paddingTop: 100,
      },
    },
    container: {
      maxWidth: 1280,
      [theme.breakpoints.up(2550)]: {
        maxWidth: 1600,
      },
    },
    wrapButton: {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      wrapButton: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 16,
        marginBottom: -40,
      },
    },
  })
);

const TarifStruk = ({ isId }: any) => {
  const classes = useStyles();
  const [loadingState, setLoadingState] = useState(true);
  const [listAsalTujuanState, setListAsalTujuanState] = useState({
    ruas: [],
    asal: [],
    tujuan: [],
    golongan: [],
  });
  const [btnCekTarifState, setBtnCekTarifState] = useState(false);
  const [btnStrukState, setBtnStrukState] = useState(false);

  const fetchAsalTujuan = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/beranda/asal-tujuan`
      );
      const resJson = await res.json();
      setListAsalTujuanState(resJson.data);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchAsalTujuan();
  }, []);

  return (
    <Box className={classes.root}>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <Grid container spacing={8} className={classes.container}>
          {loadingState ? (
            <SkeletonTarifStruk />
          ) : (
            <>
              <div className={classes.wrapButton}>
                <Fade right>
                  <Button
                    fullWidth
                    variant='contained'
                    onClick={() => setBtnCekTarifState(true)}
                  >
                    {isId ? 'Cek Tarif' : 'Check Rates'}
                  </Button>
                </Fade>

                <Fade left>
                  <Button
                    fullWidth
                    variant='contained'
                    onClick={() => setBtnStrukState(true)}
                  >
                    {isId ? 'Cari Struk' : 'Search receipt'}
                  </Button>
                </Fade>
              </div>
              <CekTarif
                isId={isId}
                listAsalTujuan={listAsalTujuanState}
                openModal={btnCekTarifState}
                onCloseModal={() => setBtnCekTarifState(false)}
              />
              <CariStruk
                isId={isId}
                openModal={btnStrukState}
                onCloseModal={() => setBtnStrukState(false)}
              />
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

export default TarifStruk;
